import React from 'react';
import Navbar from '../components/Navbar';
import NimaHero from '../components/NimaHero';
import NimaFeatures from '../components/NimaFeatures';
import NimaIntegrationGrid from '../components/NimaIntegrationGrid';

const NimaPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Navbar />
      <main>
        <NimaHero />
        
        {/* Value Prop Highlight */}
        <section className="py-24 bg-white border-y border-gray-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-6">
              High Performance. <span className="text-indigo-600">Low Integration Costs.</span>
            </h2>
            <p className="text-gray-600 text-xl max-w-3xl mx-auto mb-10 leading-relaxed">
              Why pay for separate automation tools when Nima is built directly into your event platform? We've reduced the cost of connectivity by 70%, giving you enterprise-grade power without the markup.
            </p>
            <div className="flex justify-center">
              <div className="bg-cyan-50 px-12 py-8 rounded-2xl border border-cyan-100 max-w-lg">
                <p className="text-cyan-600 font-black text-5xl mb-2">1,000+</p>
                <p className="text-cyan-900 font-bold uppercase tracking-wider text-sm">ACTIVE READY-TO-USE CONNECTIONS</p>
              </div>
            </div>
          </div>
        </section>

        <NimaFeatures />
        <NimaIntegrationGrid />

      </main>
    </div>
  );
};

export default NimaPage;